import { render, staticRenderFns } from "./Liquidacion_Editar.vue?vue&type=template&id=a060cd06&scoped=true"
import script from "./Liquidacion_Editar.vue?vue&type=script&lang=js"
export * from "./Liquidacion_Editar.vue?vue&type=script&lang=js"
import style0 from "./Liquidacion_Editar.vue?vue&type=style&index=0&id=a060cd06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a060cd06",
  null
  
)

export default component.exports